// extracted by mini-css-extract-plugin
export default {"BirthDateInput":"bga_a bik_z bik_kc bik_qx bik_xc bik_eg","BirthDateInput--disabled":"bga_b bik_fo"};